module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/font/notokr-light.woff2
// module id = Hg8p
// module chunks = 0